import { render } from "./ControleAutorizacoesIndex.vue?vue&type=template&id=14104861&scoped=true&ts=true"
import script from "./ControleAutorizacoesIndex.vue?vue&type=script&lang=ts"
export * from "./ControleAutorizacoesIndex.vue?vue&type=script&lang=ts"

import "./ControleAutorizacoesIndex.vue?vue&type=style&index=0&id=14104861&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14104861"]])

export default __exports__